export * from './functions'
export * from './hooks'
export * from './types'
import {
  getComments,
  getNotifications,
  getSamplePackRemixes,
  getSongRemixes,
  markNotificationAsRead
} from './functions'
import { getOneSamplePack } from './functions/getSamplePack'
import { getSamplePackCollaborators } from './functions/getSamplePackCollaborators'
import { getSamplePackRemixers } from './functions/getSamplePackRemixers'
import { useRedirects, useVerifyMediaAPI } from './hooks'

export namespace ApiService {
  export const Redirects = {
    hooks: useRedirects
  }
  export const VerifiedArpMedia = {
    hooks: useVerifyMediaAPI
  }
  export const Notifications = {
    endpoints: {
      getMany: getNotifications,
      markAsRead: markNotificationAsRead
    }
  }
  export const Comments = {
    endpoints: {
      getMany: getComments
    }
  }
  export const SamplePacks = {
    endpoints: {
      getOne: getOneSamplePack,
      collaborators: {
        getMany: getSamplePackCollaborators
      },
      remixers: {
        getMany: getSamplePackRemixers
      },
      remixes: {
        getMany: getSamplePackRemixes
      }
    }
  }
  export const ArpMedia = {
    songs: {
      endpoints: {
        remixes: {
          getMany: getSongRemixes
        }
      }
    }
  }
}
